
<ion-list lines="full" [dir]="dir">
  @for (subNav of subNavigation; track subNav) {
    <ion-item (click)="popoverController.dismiss()" [routerLink]="[subNav.link]">{{ subNav.text }}</ion-item>
  }
<!--  <ion-item (click)="popoverController.dismiss()" [routerLink]="['/our-team']">Our Team</ion-item>-->
<!--  <ion-item lines="none" (click)="popoverController.dismiss()" [routerLink]="['/careers']">Careers</ion-item>-->
</ion-list>
